import React from 'react';
import styles from './History.module.scss';
import PageTemplate from '../../templates/PageTemplate';
import Container from '../../templates/Container';
import Head from '../../elements/Head/Head';

import { ReactComponent as VenzelFive } from '../../../assets/svg/venzel_5_2color.svg';
import { useSelector } from 'react-redux';

const History = () => {
  const colorThemeRedux = useSelector((state) => state.theme.colorTheme);

  return (
    <>
      <PageTemplate>
        <Head />

        <Container>
          <section className={styles.history}>
            <h1 className={styles.title} style={colorThemeRedux ? { fontSize: 30, color: '#000' } : {}}>
              История фестиваля
            </h1>
            {!colorThemeRedux && <div className={styles.separator} />}

            <div className={styles.frame + ' ' + (colorThemeRedux ? styles.lowVisibleVersion : '')}>
              <div className={styles.content}>
                <p>
                  Красноярский край, второй по величине субъект России, в котором проживает более 150 национальностей,
                  на протяжении ряда лет является флагманом как ежедневной планомерной деятельности в деле сохранения
                  нематериального культурного наследия, так и реализации крупных эксклюзивных событий искусства мирового
                  масштаба. Безусловно, первый Фестиваль мужских хоров, состоявшийся в Красноярском крае в
                  августе-сентябре 2022 года, стал отправной точкой возрождения традиционного мужского певческого
                  искусства на территории нашей великой страны.
                </p>
                <p>
                  С 29 августа по 29 ноября 2022 года, в рамках Года культурного наследия, в Красноярском крае и
                  субъектах Российской Федерации состоялось знаменательное событие, направленное на возрождение
                  традиционной национальной культуры, – Фестиваль мужских хоров.
                </p>
                <p>
                  Фестиваль прошёл под патронатом Губернатора Красноярского края Александра Викторовича Усса и по
                  благословению Митрополита Красноярского и Ачинского Пантелеимона. Учредитель Фестиваля – министерство
                  культуры Красноярского края. Организатор Фестиваля – структурное подразделение ГЦНТ –
                  Культурно-исторический центр.
                </p>
                <p>
                  31 августа 2022 года в Успенском мужском монастыре г. Красноярска состоялась Божественная Литургия в
                  честь престольного праздника храма иконы Божией Матери «Всецарица» и первый сводный концерт с участием
                  мужских хоровых коллективов. В Большом концертном зале Красноярской краевой филармонии состоялось
                  Торжественное открытие Фестиваля мужских хоров.
                </p>
                <p>
                  В мероприятиях Фестиваля приняли участие коллективы мирового уровня из пяти стран и десяти регионов
                  Российской Федерации (Белград (Республика Сербия), Дунгуан (провинция Гуандун, Китай), Грозный
                  (Чеченская Республика, Россия), Калуга (Калужская область, Россия), Красноярск (Красноярский край,
                  Россия), Москва (Россия), Минск (Республика Беларусь), Никола-Малица (Тверская область, Россия),
                  Нью-Хейвен (США), Петрозаводск (Республика Карелия, Россия), Самара (Россия), Санкт-Петербург
                  (Россия), Саратов (Россия), Сидней (Австралия), Симферополь (Республика Крым, Россия). Эти
                  прославленные мужские хоры продемонстрировали своё мастерство в онлайн и офлайн форматах, на
                  протяжении пяти дней давая концерты по всему Красноярскому краю.
                </p>
                <p>
                  В финале Фестиваля на сцене Большого концертного зала Красноярской краевой филармонии состоялось
                  уникальное событие – сводный хор из более чем 600 мужчин, юношей и мальчиков пел произведения великих
                  русских композиторов.
                </p>
                <p>
                  Итоги первого Фестиваля мужских хоров впечатляют: состоялось более 30 мероприятий, в том числе 20
                  концертов были даны в муниципальных образованиях Красноярского края, которые посетили более 10 000
                  тысяч человек. Прямую трансляцию открытия и закрытия Фестиваля посмотрело более 60 000 человек.
                </p>
                <p>
                  Художественный руководитель Фестиваля Георгий Леонидович Сафонов (президент Федерации мужских хоров и
                  ансамблей, художественный руководитель и главный регент Праздничного хора Московского Данилова
                  монастыря), предложил провести эхо Фестиваля в Москве, а Красноярский край поддержал эту идею.
                  Насыщенность московской программы как пост-события Фестиваля мужских хоров поражает: за пять дней было
                  проведено пять творческих встреч-концертов в Москве и Московской области, в том числе
                  благотворительные, состоялась творческая мастерская и многое другое.
                </p>
                <p>
                  Фестиваль доказал, что хоровое пение для России является многовековой традицией и безусловным
                  культурным наследием. В этой связи в Красноярском крае Фестиваль мужских хоров стал одним из ключевых
                  событий Года культурного наследия народов России, объявленного в 2022 году Президентом нашей страны
                  Владимиром Владимировичем Путиным.
                </p>
                <p>
                  Первый Фестиваль мужских хоров получил высокие оценки экспертного сообщества, положительные отзывы
                  зрителей и участников Фестиваля и утвердил интерес к мужскому хоровому пению, как одному из ключевых
                  исконных видов искусства, формирующем духовно-нравственное самоопределение нации. Губернатор
                  Красноярского края Александр Викторович Усс дал высокую оценку Фестивалю мужских хоров и подтвердил,
                  что Красноярский край готов провести его вновь в 2023 году.
                </p>

                <p>
                  В соответствии с Указом Президента Российской Федерации Владимира Владимировича Путина «О проведении в
                  Российской Федерации Года педагога и наставника» от 27 июня 2022 года № 401, с целью
                  духовно-нравственного просвещения населения с 12 по 21 июня 2023 года во второй раз в Красноярском
                  крае состоялось знаменательное событие, направленное на возрождение традиционной национальной
                  культуры, – Фестиваль мужских хоров.
                </p>
                <p>
                  Фестиваль проходил под патронатом временно исполняющего обязанности Губернатора Красноярского края
                  Михаила Михайловича Котюкова и по благословению Митрополита Красноярского и Ачинского Пантелеимона.
                  Учредитель Фестиваля – министерство культуры Красноярского края. Организатором Фестиваля является
                  структурное подразделение ГЦНТ – Культурно-исторический центр.
                </p>
                <p>
                  В рамках события состоялось 40 мероприятий, которые посетили более 15 000 человек, в том числе 20
                  концертных программ были представлены в муниципальных образованиях Красноярского края: Ачинск,
                  Березовка, Боготол, Бородино, Большая Мурта, Дивногорск, Емельяново, Железногорск, Зеленогорск,
                  Иланский, Казачинское, Канск, Каратузское, Минусинск, Назарово, Новосёлово, Сосновоборск, Уяр,
                  Шарыпово, Шушенское.
                </p>
                <p>
                  В концертных программах Фестиваля приняли участие прославленные мужские и детско-юношеские хоры из
                  Армении, Сербии, Беларуси, Воронежа, Екатеринбурга, Грозного, Иваново, Королёва, Красноярска, Москвы,
                  Санкт-Петербурга, Северной Осетии-Алании, Симферополя, Твери и др.
                </p>
                <p>
                  15 июня 2023 года в Малом концертном зале им. И.В. Шпиллера Красноярской краевой филармонии состоялся
                  концерт, посвящённый 150-летию со дня рождения С.В. Рахманинова и Ф.И. Шаляпина.
                </p>
                <p>
                  18 июня 2023 года в Органном зале Красноярской краевой филармонии для зрителей была представлена
                  творческая встреча-концерт «Аве Мария», на которой прозвучали произведения выдающихся зарубежных и
                  российских, в том числе красноярских, композиторов, восхваляющих образ Пречистой Девы Марии.
                </p>
                <p>
                  19 июня 2023 года в Большом концертном зале Красноярской краевой филармонии состоялся гала-концерт
                  Фестиваля мужских хоров, на котором ведущие хоровые коллективы мирового уровня показали свое
                  мастерство. В финале концертной программы сводный хор из более чем 700 мужчин и юношей – участников
                  Фестиваля исполнил музыкальные шедевры русской культуры.
                </p>
                <p>
                  С 16 июля по 19 ноября 2023 года состоялось 8 пост-событий Фестиваля в субъектах Российской Федерации
                  и муниципальных образований Красноярского края, в т.ч. в г. Енисейск, г. Красноярск, пгт. Курагино, г.
                  Лесосибирск, г. Москва, г. Симферополь, пгт. Стрелка, с. Тесь. Первым пост-событием Фестиваля стал
                  специальный проект «Певческий берег», который прошёл 16 июля 2023 года на набережной реки Енисей у
                  стен Успенского мужского монастыря города Красноярска. Сводный мужской хор исполнил Песнопения Русской
                  Православной Церкви, произведения великого русского композитора Сергея Рахманинова, народные песни из
                  репертуара выдающегося русского певца Фёдора Шаляпина, песни российских авторов «Беловежская пуща»,
                  «Зачарованная даль» и др., а в финале концерта прозвучало патриотическое произведение Михаила Глинки
                  «Славься». Количество зрителей мероприятия составило 3 500 человек.
                </p>

                <p>
                  Со 02 по 12 сентября 2024 года в рамках Года Семьи, объявленного Президентом Российской Федерации
                  Владимиром Владимировичем Путиным, в Красноярском крае состоялось знаменательное событие, направленное
                  на возрождение традиционной национальной культуры и патриотическое воспитание, – Фестиваль мужских
                  хоров, который стал третьим по счету. В этом году география участников Фестиваля и места проведения
                  пред-событий стали масштабнее.
                </p>
                <p>
                  Фестиваль прошёл под патронатом Губернатора Красноярского края Михаила Михайловича Котюкова и по
                  благословению Митрополита Красноярского и Ачинского Пантелеимона. Учредитель Фестиваля – министерство
                  культуры Красноярского края. Организатор Фестиваля – структурное подразделение ГЦНТ –
                  Культурно-исторический центр.
                </p>
                <p>
                  В Фестивале приняли участие 16 мужских хоровых коллективов и 4 специальных гостя Фестиваля. В числе
                  участников Фестиваля 13 коллективов из субъектов Российской Федерации (в том числе 1 специальный гость
                  из города Москва), 1 коллектив из Республики Беларусь, 1 коллектив из Республики Армения, 1 коллектив
                  из Республики Казахстан, 1 коллектив из Грузии, 1 специальный гость из Китайской Народной Республики,
                  1 специальный гость из Республики Сербия.
                </p>
                <p>
                  13 июня 2024 года как пред-событие Фестиваля состоялся концерт Сибирского мужского хора при Храме
                  Успения Пресвятой Богородицы на территории Посольства Российской Федерации в городе Пекине Китайской
                  Народной Республики.
                </p>
                <p>
                  08 июля 2024 года на набережной реки Енисей, у стен Успенского мужского монастыря состоялось второе
                  пред-событие Фестиваля мужских хоров – специальный проект «Певческий берег», посвящённый Дню семьи,
                  любви и верности. Участниками проекта стали три фундаментальных хоровых коллектива Федерации мужских
                  хоров и ансамблей: Мужской хор «Всехсвятский» под руководством лауреата международных конкурсов
                  Дмитрия Токмакова (Республика Беларусь, г. Минск), Праздничный хор Данилова монастыря под руководством
                  главного регента Георгия Сафонова (Российская Федерация, г. Москва) и Сибирский мужской хор под
                  руководством лауреата международных и всероссийских хоровых конкурсов и фестивалей Василия Андреева
                  (Российская Федерация, Красноярский край, г. Красноярск), а также образцовая детская оперная студия
                  Красноярского государственного театра оперы и балета имени Д.А. Хворостовского под руководством
                  заслуженного работника культуры Красноярского края Наталии Цюпы (Российская Федерация, Красноярский
                  край, г. Красноярск).
                </p>
                <p>
                  В рамках концерта сводный мужской хор исполнил Песнопения Русской Православной Церкви, патриотические
                  и лирические произведения выдающихся русских композиторов (П.И. Чайковский, Г.В. Свиридов, А.Н.
                  Пахмутова, Н.Н. Добронравов, В.А. Гаврилин и др.) и премьеру музыкального произведения «Песнопение о
                  Петре и Февронии» (музыка А.О. Вискова, слова Е.Г. Григорьева). Весь музыкальный материал был посвящён
                  теме семейных ценностей, что стало очень символичным в Год семьи.
                </p>
                <p>
                  29 августа 2024 года в Красноярском государственном театре оперы и балета имени Д.А. Хворостовского
                  состоялось пред-событие Фестиваля мужских хоров: мировая премьера – музыкально-драматический спектакль
                  «Между небом и землёй», посвящённый житию Святителя Луки (Войно-Ясенецкого).
                </p>
                <p>
                  В спектакле приняли участие Праздничный хор Московского Данилова монастыря, Сибирский мужской хор,
                  образцовая детская оперная студия Красноярского государственного театра оперы и балета, заслуженная
                  артистка России Екатерина Гусева, иеромонах Кирилл (Перегудин).
                </p>
                <p>
                  09 сентября 2024 года в Большом концертном зале Красноярской краевой филармонии состоялся Гала-концерт
                  Фестиваля мужских хоров, на котором ведущие хоровые коллективы мирового уровня продемонстрировали свое
                  мастерство. На мероприятии присутствовали представители духовенства, исполнительной и законодательной
                  власти Красноярского края, члены экспертного совета фестиваля, семьи участников СВО, работники
                  социальной сферы, ветераны, инвалиды, педагоги и учащиеся краевых государственных учреждений культуры,
                  профессиональных образовательных учреждений в области культуры, образовательных организаций высшего
                  образования и многие другие.
                </p>

                <p>
                  Целью Фестиваля мужских хоров остается сохранение и позиционирование нематериального культурного
                  наследия России. Задачами Фестиваля являются развитие традиций мужского хорового исполнительства,
                  духовной культуры, духовно-нравственное просвещение населения Красноярского края, усиление имиджа и
                  привлекательности Енисейской Сибири, пропаганда патриотизма и любви к Отчизне, добрососедские
                  отношения, а также укрепление международного сотрудничества с дружественными странами.
                </p>
                <p>
                  С июля по октябрь 2025 года в Красноярском крае в четвёртый раз состоится знаменательное событие,
                  направленное на возрождение традиционной национальной культуры, – Фестиваль мужских хоров.
                </p>
                <p>
                  Фестиваль проходит под патронатом Губернатора Красноярского края Михаила Михайловича Котюкова и по
                  благословению Митрополита Красноярского и Ачинского Никиты. Учредитель Фестиваля – министерство
                  культуры Красноярского края. Организатор Фестиваля – структурное подразделение ГЦНТ –
                  Культурно-исторический центр.
                </p>
                <p>
                  За дни Фестиваля пройдёт более 50 мероприятий, в том числе свыше 30 концертных программ будут
                  представлены в муниципальных образованиях Красноярского края, на которых выступят прославленные
                  мужские хоры из различных субъектов Российской Федерации (Республика Крым, Луганская Народная
                  Республика, Красноярский край, Московская область, гг. Москва, Севастополь, Ульяновск и др.), а также
                  зарубежья – Грузия, Китайская Народная Республика, Республика Беларусь, Республика Казахстан,
                  Республика Сербия.
                </p>
                <p>
                  Фестиваль традиционно начнётся специальным проектом «Певческий берег» – 08 июля 2025 года на
                  набережной реки Енисей у стен Успенского мужского монастыря города Красноярска будут исполнять
                  духовные и патриотические песни Академический ансамбль песни и пляски Российской Армии имени А.В.
                  Александрова, Праздничный хор Данилова монастыря (г. Москва), мужские хоры «Всехсвятский» (Республика
                  Беларусь), «Сихарули» (Грузия), Молодёжный хор дирижёров провинции Хэнань (Китайская Народная
                  Республика), а также Сибирский мужской хор (г. Красноярск).
                </p>
                <p>
                  Гала-концерты Фестиваля мужских хоров пройдут 09-10 октября в Большом концертном зале Красноярской
                  краевой филармонии.
                </p>
              </div>

              <VenzelFive />
              <VenzelFive />
              <VenzelFive />
              <VenzelFive />
            </div>

            {!colorThemeRedux && <div className={styles.separator + ' ' + styles.separator_down} />}
          </section>
        </Container>
      </PageTemplate>
    </>
  );
};

export default History;
